export const getters = {
  systemInterchanges: state => state.interchanges
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/interchanges/getters.js